export default __webpack_public_path__ + "static/media/extend-booking.00a39838.svg";